import { useEffect, useState } from 'react';
import { Button as KitButton, Modal as KitModal } from '../../school_panel/components/ui';
import AssignFields, { assignFromExam, assignPayload, assignError, EMPTY_ASSIGN, type AssignValue } from './AssignFields';

const FIELD_KEYS = ['due_at', 'due_date', 'instructions', 'assigned_section_ids', 'assigned_student_ids'];

export default function EditAssignmentModal({ isOpen, onClose, exam, saving, save }: {
  isOpen: boolean; onClose: () => void; exam: any; saving?: boolean;
  /** Resolves editExamInfo's result: `{ exam }` on success, otherwise the swallowed error object. */
  save: (payload: ReturnType<typeof assignPayload>) => Promise<any>;
}) {
  const [draft, setDraft] = useState<AssignValue>(EMPTY_ASSIGN);
  const [errs, setErrs] = useState<Record<string, string>>({});

  useEffect(() => {
    if (isOpen) { setDraft(assignFromExam(exam ?? {})); setErrs({}); }
    // seed once per open
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const submit = async () => {
    const msg = assignError(draft);
    if (msg) { setErrs({ [draft.mode === 'students' ? 'assigned_student_ids' : 'assigned_section_ids']: msg }); return; }
    setErrs({});
    let res: any;
    try { res = await save(assignPayload(draft, exam?.assignment_scope)); } catch (e) { res = e; }
    if (res?.exam) { onClose(); return; }
    const body = res?.response?.data;
    const out: Record<string, string> = {};
    for (const k of FIELD_KEYS) {
      const v = body?.[k];
      if (v) out[k === 'due_date' ? 'due_at' : k] = Array.isArray(v) ? String(v[0]) : String(v);
    }
    setErrs(Object.keys(out).length ? out : { _form: 'Could not save the assignment. Try again.' });
  };

  return (
    <KitModal
      isOpen={isOpen}
      onClose={onClose}
      title="Edit assignment"
      size="lg"
      footer={(
        <>
          <KitButton variant="ghost" onClick={onClose}>Cancel</KitButton>
          <KitButton onClick={submit} loading={saving}>Save assignment</KitButton>
        </>
      )}
    >
      {errs._form && <p role="alert" className="mb-3 rounded-lg border border-danger/30 bg-danger/10 px-3 py-2 text-sm text-danger">{errs._form}</p>}
      <AssignFields gradeId={exam?.school_grade_id ?? null} kind={exam?.kind ?? 'exam'} value={draft} onChange={setDraft} errors={errs} />
    </KitModal>
  );
}
